// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8974) return "8974.655f4c90ffa98c5f9c8e.app-chunk.min.js?v=1758198934965";
	if (chunkId === 3470) return "3470.19e4347fc2f8c9f13860.app-chunk.min.js?v=1758198934965";
	if (chunkId === 3602) return "notification.ba60e1dd20326eb6e1b0.app-chunk.min.js?v=1758198934965";
	if (chunkId === 6714) return "sticky-cart-new-4-0-14.e0f2c91e7a336489d2bc.app-chunk.min.js?v=1758198934965";
	if (chunkId === 8075) return "wishlist-new-4-0-3.1f600ad2f4daa9e2bc14.app-chunk.min.js?v=1758198934965";
	if (chunkId === 4026) return "new-customer-pop.98aef2fb064da686db10.app-chunk.min.js?v=1758198934965";
	if (chunkId === 9964) return "membership-packet.5cbfcc836ba95eb1bb9d.app-chunk.min.js?v=1758198934965";
	// return url for filenames based on template
	return undefined;
};